import { definition, signal, metadata, api, component } from "@uesio/ui"
import { default as IOMenuButton } from "../../utilities/menubutton/menubutton"

type MenuItemDefinition = {
  id: string
  label: string
  signals?: signal.SignalDefinition[]
  [component.DISPLAY_CONDITIONS]?: component.DisplayCondition[]
}

type MenuButtonDefinition = {
  icon?: string
  items: MenuItemDefinition[]
  buttonVariant?: metadata.MetadataKey
}

const MenuButton: definition.UC<MenuButtonDefinition> = (props) => {
  const { definition, context } = props

  const { items, icon, buttonVariant } = definition

  const filteredItems = items.filter((item) =>
    component.shouldAll(item[component.DISPLAY_CONDITIONS], context),
  )

  return (
    <IOMenuButton
      itemRenderer={(item: MenuItemDefinition) => item.label}
      items={filteredItems}
      onSelect={(item: MenuItemDefinition) => {
        if (!item.signals) return
        api.signal.runMany(item.signals, context)
      }}
      getItemKey={(item: MenuItemDefinition) => item.id}
      icon={icon}
      context={context}
      buttonVariant={buttonVariant}
      styleTokens={definition[component.STYLE_TOKENS]}
    />
  )
}

export default MenuButton
